import React, { useState } from 'react';
import { Button, Form, Col, Card, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';
import * as Constants from '../Constants/Constants';

const ContactUs = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Form submitted:', { firstName, lastName, email, message });

    const data = {
      fname: firstName,
      lname: lastName,
      email: email,
      message: message,
    };
  
    axios.post(`${Constants.BASE_URL}?apitype=203`, data)
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Form submitted successfully',
        });
        setFirstName("");
        setLastName("");
        setEmail("");
        setMessage("");
        console.log('Response:', response.data);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'There was a problem submitting the form',
        });
        console.error('Error:', error);
      });


    
  };

  return (
    <div className="container mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow">
            <Card.Body>
              <h1 className="text-center mb-4">Contact Us</h1>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="firstName" className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter first name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="lastName" className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter last name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group controlId="message" className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter your message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  />
                </Form.Group>
                <div className="d-grid">
                  <Button variant="primary" type="submit">
                    Send Message
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Map below the card */}
      <Row className="justify-content-center mt-4">
        <Col md={8} lg={6}>
          <div className="map-container" style={{ border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
          <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15550.765217811186!2d77.5938123!3d12.9915854!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1642f0cdc223%3A0x738bc50fd0558e2c!2sKunchitigara%20Sarvajanika%20Vidyarthi%20Nilaya!5e0!3m2!1sen!2sin!4v1727947889124!5m2!1sen!2sin"
  width="600"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

          </div>
        </Col>
      </Row>

      {/* Contact details below the map */}
      <Row className="justify-content-center mt-4">
        <Col md={8} lg={6}>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body className="text-center">
              <Card.Title className="mb-3">
                <strong>KSV Nilaya</strong>
              </Card.Title>
              <Card.Text>
                Vasantha Nagar<br />
                Millers Road<br />
                Bengaluru – 560 052.
              </Card.Text>
              <Card.Text>
                Email ID: <a href="mailto:kusavini@gmail.com">kusavini@gmail.com</a>
              </Card.Text>
              <Card.Text>
                Phone No.: <em>Will update soon</em>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContactUs;
